// These constants are injected via webpack environment variables.
// You can add more variables in webpack.common.js or in profile specific webpack.<dev|prod>.js files.
// If you change the values in the webpack config files, you need to re run webpack to update the application
export const VERSION = process.env.VERSION;
// export const DEBUG_INFO_ENABLED: boolean = !!process.env.DEBUG_INFO_ENABLED;
export const SERVER_API_URL = process.env.SERVER_API_URL;
export const BUILD_TIMESTAMP = process.env.BUILD_TIMESTAMP;
export const KIT_UI_URL = process.env.BUILD_TIMESTAMP;
export const TLSPAY_ENABLE = process.env.TLSPAY_ENABLE === 'true';
export const PAYMENT_SERVICE_DOMAIN = process.env.PAYMENT_SERVICE_DOMAIN;
export const CUSTOMER_SERVICE_URL = process.env.CUSTOMER_SERVICE_URL;
export const MINIO_BUCKET_ADDRESS = process.env.MINIO_BUCKET_ADDRESS;
export const GENERATE_SITEMAP_ISSUER = process.env.GENERATE_SITEMAP_ISSUER;
export const DIRECTUS_V9_URL = process.env.DIRECTUS_V9_URL;
export const TLSCITIZEN_WEBAPP_URL = process.env.TLSCITIZEN_WEBAPP_URL;

export const LOCAL_COUNTRY = process.env.TARGET_CLIENT;
export const POLISH_CENTER = process.env.TARGET_CLIENT === 'pl';
export const MAX_OTP_SMS_TIMES = process.env.MAX_OTP_SMS_TIMES || 2;
export const IS_FRANCE_CLIENT = process.env.TARGET_CLIENT === 'fr';
export const FORM_STEP_SKIP = process.env.FORM_STEP_SKIP === 'true';
export const APPOINTMENT_STEP_SKIP = process.env.APPOINTMENT_STEP_SKIP === 'true';
export const HIDE_TVA = process.env.HIDE_TVA === 'true';
export const ALLOW_REQUEST_INSTRUCTION_API = process.env.ALLOW_REQUEST_INSTRUCTION_API === 'true';
export const PIWIK_PROPERTY_ID = process.env.PIWIK_PROPERTY_ID;
export const REDIRECT_URL = process.env.REDIRECT_URL;
export const REDIRECT_COUNTRY_CODE = process.env.REDIRECT_COUNTRY_CODE;
export const ADS_SKIP_TLSPAY = process.env.ADS_SKIP_TLSPAY;
export const AGEN_BYPASS_TLSPAY = process.env.AGEN_BYPASS_TLSPAY;
export const COMP_BYPASS_TLSPAY = process.env.COMP_BYPASS_TLSPAY;
export const AFP_SKIP_TLSPAY = process.env.AFP_SKIP_TLSPAY;
export const FORBID_AVS_IN_CART = process.env.FORBID_AVS_IN_CART;
export const ALLOWED_BYPASS_TLSPAY_PASSPORT = process.env.ALLOWED_BYPASS_TLSPAY_PASSPORT;
export const BLOCK_NON_LATIN_CHARACTERS = process.env.BLOCK_NON_LATIN_CHARACTERS === 'true';
export const FORBID_PASTE_FORM_FILLING = process.env.FORBID_PASTE_FORM_FILLING === 'true';
// travel purpose default 999
export const APPOINTMENT_LOCK_DURATION_DEFAULT = 999;
export const HMPO_UK = 'hmpo_uk';
export const LEG_BE = 'leg-be';
export const PROJECT_NAME = 'TLS_WEB';
export const GLOBAL_FILTER = 'global';
export const ALL_COUNTRY_CODE = 'all';
export const ALL_ISSUER_CODE = 'all';
export const APPOINTMENT_TYPE_PTA = 'prime time';
export const APPOINTMENT_TYPE_PTA_WEEKEND = 'prime time weekend';
export const APPOINTMENT_TYPE_PREMIUM_LOUNGE = 'premium';
export const APPOINTMENT_TYPE_NORMAL = 'normal';
export const INDI_TYPE = 'INDI';
export const AGENCE_TYPE = 'AGEN';
export const COMPANY_TYPE = 'COMP';
export const ADS_TYPE = 'ADS';
export const SCHENGEN_CSL = 'schengen_csl';
export const DUPLICATE_GROUP_PREFIX = 'new appointment group for forms [';
export const STAGE_SUBMISSION = 'submission';
export const STAGE_DOCUMENTATION = 'documentation';
export const STAGE_APPOINTMENT = 'appointment';
export const STAGE_CSL_APPOINTMENT = 'csl_appointment';
export const STAGE_STATUS = 'status';
export const PENDING_STATUS = 'pending';
export const SKIPPED_STATUS = 'skipped';
export const DECLINED_STATUS = 'declined';
export const DONE_STATUS = 'done';
export const BOOK_STATUS = 'book';
export const NA_STATUS = 'n_a';
export const TAKEN_STATUS = 'taken';
export const WITHDRAWN_STATUS = 'withdraw';
export const WITHDRAWN = 'withdrawn';
export const BOOK_APPOINTMENT_ACTION = 'book_appointment';
export const BOOK_CSL_APPOINTMENT_ACTION = 'book_csl_appointment';
export const TAKE_APPOINTMENT_ACTION = 'take_appointment';
export const RECEIVE_AFP_FEES_ACTION = 'receive_afp_fees';
export const TAKE_CSL_APPOINTMENT_ACTION = 'take_csl_appointment';
export const POSTAL_RECEIVED_ACTION = 'postapp_received';
export const POSTAL_SENT_ACTION = 'postapp_sent';
export const PTA_SKU = 'PRIME-TIME-APPOINTMENT';
export const PRIME_TIME_APPOINTMENT_6_12_YEARS_OLD_SKU = 'PRIME-TIME-APPOINTMENT-6-12-YEARS-OLD';
export const PRIME_TIME_APPOINTMENT_UNDER_6_YEARS_OLD_SKU = 'PRIME-TIME-APPOINTMENT-UNDER-6-YEARS-OLD';
export const PREMIUM_LOUNGE_SKU = 'PREMIUM-LOUNGE';
export const PREMIUM_LOUNGE_APPOINTMENT_6_12_YEARS_OLD_SKU = 'PREMIUM-LOUNGE-6-12-YEARS-OLD';
export const PREMIUM_LOUNGE_APPOINTMENT_UNDER_6_YEARS_OLD_SKU = 'PREMIUM-LOUNGE-UNDER-6-YEARS-OLD';
// client fr is PRIME_TIME_WEEKEND_SKU , other is PTA_WEEKEND_SKU
export const PTA_WEEKEND_SKU = 'PRIME-TIME-APPOINTMENT-WEEKEND';
export const PRIME_TIME_WEEKEND_SKU = 'PRIME-TIME-WEEKEND';
export const PRIME_TIME_WEEKEND_6_12_YEARS_OLD_SKU = 'PRIME-TIME-WEEKEND-6-12-YEARS-OLD';
export const PRIME_TIME_WEEKEND_UNDER_6_YEARS_OLD_SKU = 'PRIME-TIME-WEEKEND-UNDER-6-YEARS-OLD';
export const EXPRESS_COURIER_SKU = 'express-courier-return';
export const VAC_WORKFlOW = 'vac';
export const POSTAL_WORKFLOW = 'postal';
export const VAC_AND_POSTAL = 'vac,postal';
export const GATEWAY_PAY_BANK = 'pay_bank';
export const GATEWAY_PAY_ONSITE = 'pay_later';
export const ISSUER_REDIRECT_TOKEN = 'issuer_redirect';
export const HMPO_DNA_VISA_TYPE = 'hmpo_dna';
export const HMPO_DNA_AVS = 'DNA_TESTING';
export const NO_AFP = 'afp_config_no_afp';
export const AFP_CANCELLATION = 'afp_config_with_appointment';
export const AFP_LOCKED = 'afp_config_only';
export const PAYMENT_REFUND_COMPLETED_STATUS = 'payment_refund_completed';
export const ATTEND_APPOINTMENT = 'attend_appointment';
export const PAYMENT_REFUND_REJECTED_STATUS = 'payment_refund_rejected';
export const FORM_GROUP_PURGED = 'FormGroupPurged';
export const ACCOUNT_PURGED = 'AccountPurged';
export const OSANO = 'Osano';
export const CronJobCancelAppointmentComment = 'cron job cancel this book_appointment';
export const ON_DEMAND = 'On Demand';
export const CANCEL_APPOINTMENT_COMMENT = 'Cancel appointment time';
export const INSTRUCTION_TYPE = 'digital_doc_completion_instruction';
export const NO_TIME = 'N/A';
export const DISPLAY_RIBBON_ON_PROFILES = 'dev';
export const SPRING_PROFILES_ACTIVE = process.env.SPRING_PROFILES_ACTIVE;
export const NO_AFP_BYPASS_TLSPAY = process.env.NO_AFP_BYPASS_TLSPAY;
export const LOCATION_BYPASS_TLSPAY = process.env.LOCATION_BYPASS_TLSPAY;
export const JWT_FORMS_SECRET_KEY = process.env.JWT_FORMS_SECRET_KEY;
export const BEVOW_WORKFLOW_INTEGRATION_ISSUERS = process.env.BEVOW_WORKFLOW_INTEGRATION_ISSUERS || '';
export const DEFAULT_LANGUAGE = 'en-us';

// DataDog
export const DATADOG_APPLICATION_ID = process.env.DATADOG_APPLICATION_ID;
export const DATADOG_CLIENT_TOKEN = process.env.DATADOG_CLIENT_TOKEN;
export const DATADOG_SERVICE = process.env.DATADOG_SERVICE;
export const DATADOG_ENV = process.env.DATADOG_ENV;
export const DATADOG_VERSION = process.env.DATADOG_VERSION;
export const DATADOG_SESSION_SAMPLE_RATE = Number(process.env.DATADOG_SESSION_SAMPLE_RATE);
export const DATADOG_SESSION_REPLAY_SAMPLE_RATE = Number(process.env.DATADOG_SESSION_REPLAY_SAMPLE_RATE);

export enum CookieConsentValue {
  ACCEPTED = 'accepted',
  REJECTED = 'rejected'
}
export enum InquiryStatus {
  ERROR,
  PENDING,
  SUCCESS
}
export enum StatusValue {
  PENDING = 'pending',
  DONE = 'done'
}

export enum InstructionStatus {
  Completed = 'consulate_decision_applicant_confirmed',
  Cancelled = 'consulate_decision_cancelled',
  Closed = 'consulate_decision_receive',
  Expired = 'expired',
  Pending = 'consulate_decision_send',
  Applicant = 'consulate_decision_contact_applicant'
}

// Errors
export const PROBLEM_BASE_URL = 'https://www.jhipster.tech/problem';
export const EMAIL_ALREADY_USED_TYPE = PROBLEM_BASE_URL + '/email-already-used';
export const LOGIN_ALREADY_USED_TYPE = PROBLEM_BASE_URL + '/login-already-used';
export const EMAIL_NOT_FOUND_TYPE = PROBLEM_BASE_URL + '/email-not-found';

// GOOGLE RECAPTCHA
export let APPLY_GOOGLE_RECAPTCHA = process.env.APPLY_GOOGLE_RECAPTCHA === 'true';
export const GOOGLE_RECAPTCHA_SITE_KEY = process.env.GOOGLE_RECAPTCHA_SITE_KEY;
export let GOOGLE_RECAPTCHA_BYPASS_COUNTRIES = process.env.GOOGLE_RECAPTCHA_BYPASS_COUNTRIES;
export let USE_RECAPTCHANET = process.env.USE_RECAPTCHANET === 'true';
